<template>
  <div>
    <div class="grid">
      <div class="grid-title">
        <div class="row">
          <div class="col-md-6">
            <h4>
              Accessories Orders
              <span class="badge badge-danger">
                Total : {{ totalRecords }}
              </span>
            </h4>
          </div>
          <div class="col-md-6 text-right">
            <button
              class="btn btn-primary"
              @click="newOrder"
              v-if="!isReadOnlyUser"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> New Order
            </button>
          </div>
        </div>
      </div>

      <div class="grid-body">
        <div class="row mb-10">
          <div class="col-md-4">
            <input
              type="text"
              class="form-control"
              @keyup.enter="searchOrder($event.target.value)"
              placeholder="Search ..."
            />
          </div>
          <div class="col-md-2 p-4">
            All &nbsp;<toggle-button
              @change="getOrders"
              v-model="notArrivedToggle"
            />
            &nbsp; Not Arrived
          </div>
          <div class="col-md-2 text-right filter-container">
            Filter by status:
          </div>
          <div class="col-md-4">
            <select class="form-control search-type" v-model="selectedStatusFilter" @change="filterByStatus">
              <option value="">All statuses</option>
              <option v-for="status in availableStatus" :value="status.value">
                {{ status.name }}
              </option>
            </select>
          </div>
        </div>

        <vue-good-table
          mode="remote"
          ref="order_table"
          @on-page-change="onPageChange"
          @on-selected-rows-change="selectionChanged"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
          :select-options="{ enabled: true, selectOnCheckboxOnly: true }"
          :totalRows="totalRecords"
          styleClass="table table-bordered"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
          }"
          :columns="columns"
          :rows="orders"
        >
          <template slot="table-row" slot-scope="props">
            <!-- amount -->
            <span v-if="props.column.field === 'amount'">
              {{ props.row.amount }}
            </span>

            <!-- fabric  -->
            <span
              v-else-if="
                props.column.field === 'fabrics' &&
                props.row.fabrics &&
                props.row.fabrics.length > 0
              "
            >
              <span v-for="(fabric, index) in props.row.fabrics" :key="fabric">
                <router-link
                  :to="{ name: 'fabric_update', params: { id: fabric } }"
                >
                  {{ $Fabric.getCode(fabric)
                  }}<span v-if="index < props.row.fabrics.length - 1">,</span>
                </router-link>
              </span>
            </span>

            <!-- urgent status -->
            <span v-else-if="props.column.field === 'urgent'">
              <span class="badge badge-primary" v-if="props.row.urgent">
                Yes
              </span>
              <span v-else class="badge badge-danger"> No </span>
            </span>

            <!-- comments -->
            <span v-else-if="props.column.field === 'comments'">
              <div
                class="comments-holder"
                v-for="(comment, index) in props.row.comments"
                :key="index"
              >
                {{
                  comment.text && comment.text.length > 60
                    ? comment.text.slice(0, 60) + "..."
                    : comment.text
                }}
              </div>
              <span
                class="btn btn-primary btn-sm pointer"
                @click="showComments(props.row.originalIndex)"
                v-if="!isReadOnlyUser"
              >
                ...
              </span>
            </span>

            <!-- amount -->
            <span v-else-if="props.column.field === 'created_at'">
              {{ ezy.date(props.row.created_at) }}
            </span>

            <!-- Status -->
            <span
              v-else-if="props.column.field === 'status'"
              class="text-uppercase"
            >
              <v-select
                placeholder="Select Item"
                v-model="props.row.status"
                @input="changeStatus(props.row.originalIndex, props.row.status)"
                :options="availableStatus"
                :reduce="(option) => option.value"
                label="name"
              >
              </v-select>
            </span>

            <span v-else-if="props.column.field === 'action'">
              <div class="btn-group fabric-dropdown" v-if="!isReadOnlyUser">
                <button
                  data-toggle="dropdown"
                  class="btn btn-sm btn-info dropdown-toggle"
                >
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu pull-right">
                  <!-- <li> <a class="pointer" @click="changeStatus(props.row.originalIndex)">Change Status</a></li>  -->
                  <li>
                    <a
                      class="pointer"
                      @click="editOrder(props.row.originalIndex)"
                      >Edit</a
                    >
                  </li>
                  <li>
                    <a
                      class="pointer"
                      @click="deleteOrder(props.row.originalIndex)"
                      >Delete</a
                    >
                  </li>
                </ul>
              </div>
            </span>

            <!-- others -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <div slot="selected-row-actions">
            <div class="btn-group fabric-dropdown" v-if="!isReadOnlyUser">
              <button
                data-toggle="dropdown"
                class="btn btn-sm btn-info dropdown-toggle"
              >
                Action <span class="caret"></span>
              </button>
              <ul class="dropdown-menu pull-right">
                <li>
                  <a class="pointer" @click="changeStatusMultiple()"
                    >Change Status</a
                  >
                </li>
                <li><a class="pointer" @click="deleteMultiple()">Delete</a></li>
              </ul>
            </div>
          </div>
        </vue-good-table>
      </div>
    </div>

    <order-modal
      @submit="submitOrder"
      :params="params"
      :selectedIndex="selectedIndex"
    />
    <comment-modal :order="selectedOrder" @submit="submitComments" />
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import OrderModal from "./Components/OrderModal";
import CommentModal from "./Components/CommentModal";

export default {
  components: {
    VueGoodTable,
    OrderModal,
    CommentModal,
  },
  data() {
    return {
      orders: [],
      notArrivedToggle: true,
      isReadOnlyUser: false,
      availableStatus: [
        { value: "new", name: "New" },
        { value: "started", name: "Started" },
        { value: "shipped", name: "Shipped" },
        { value: "arrived", name: "Arrived" },
      ],
      params: { comments: [{ text: null }] },
      totalRecords: 0,
      selectedIndex: null,
      selectedItems: [],
      selectedOrder: { comments: [] },
      selectedStatusFilter: '',
      serverParams: {
        page: 1,
        perPage: 10,
        keyword: null,
        notArrived: true,
        orderBy: { column: "id", type: "desc" },
        status: null
      },
      columns: [
        {
          label: "Item Name",
          field: "item_name",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Amount",
          field: "amount",
          tdClass: "text-right",
          thClass: "text-center",
        },
        {
          label: "Fabrics",
          field: "fabrics",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Urgent",
          field: "urgent",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "comments",
          field: "comments",
          tdClass: "text-center",
          thClass: "text-center",
          sortable: false,
        },
        {
          label: "Date created",
          field: "created_at",
          tdClass: "text-center",
          thClass: "text-center",
          sortable: true,
        },
        {
          label: "status",
          field: "status",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "",
          field: "action",
          tdClass: "text-right",
          thClass: "text-right",
          sortable: false,
        },
      ],
      //end of vue data
    };
  },

  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getOrders();
  },

  methods: {
    newOrder() {
      this.selectedIndex = null;
      this.params = {
        comments: [
          {
            text: null,
            username:
              this.$auth.user().first_name + " " + this.$auth.user().last_name,
          },
        ],
        fabric_id: null,
        item_name: null,
        urgent: false,
        status: "new",
      };
      show_modal("#order-modal");
    },

    async showChangeStatusDialog(status) {
      const { value: newStatus } = await Swal.fire({
        title: "Select Status",
        input: "select",
        inputValue: status,
        inputOptions: {
          new: "New",
          started: "Started",
          shipped: "Shipped",
          arrived: "Arrived",
        },
        inputPlaceholder: "Select Status",
        showCancelButton: true,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value) {
              resolve();
            } else {
              resolve("Please Select One");
            }
          });
        },
      });
      return newStatus;
    },

    async changeStatus(index, newStatus) {
      let order = this.orders[index];
      // let status = await this.showChangeStatusDialog(order.status);
      let status = newStatus;
      if (status) {
        this.orders[index].status = status;
        try {
          let res = await axios.put(
            "accessories_order/" + order.id,
            this.orders[index]
          );
          toastr.success("Successfully Changed Status");
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async changeStatusMultiple() {
      let status = await this.showChangeStatusDialog("new");
      if (status) {
        try {
          let res = await axios.put("accessories_order/batch", {
            ids: this.selectedItems,
            status,
          });
          if (res) {
            this.orders = this.orders.map((order) => {
              if (this.selectedItems.includes(order.id)) {
                order.status = status;
              }
              return order;
            });
            toastr.success("Successfully Channged Status");
            this.selectedItems = [];
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async deleteOrder(index) {
      let order = this.orders[index];
      if (await ezy.confirm("Are you sure to delete?", "DELETE")) {
        try {
          let res = await axios.delete("accessories_order/" + order.id);
          if (res) {
            toastr.success("Successfully Deleted");
            this.orders.splice(index, 1);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async deleteMultiple() {
      if (await ezy.confirm("Are you sure to delete?", "DELETE")) {
        try {
          let res = await axios.delete("accessories_order/batch", {
            data: { ids: this.selectedItems },
          });
          if (res) {
            this.orders = this.orders.filter((order) => {
              return !this.selectedItems.includes(order.id);
            });
            toastr.success("Successfully Deleted");
            this.selectedItems = [];
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    editOrder(index) {
      this.selectedIndex = index;
      if (this.orders[index].comments.length === 0) {
        this.orders[index].comments = [{ text: null }];
      }
      this.params = this.orders[index];
      show_modal("#order-modal");
    },

    submitComments(comments) {
      this.orders[this.selectedIndex].comments = comments;
    },

    async showComments(index) {
      this.selectedOrder = this.orders[index];
      this.selectedIndex = index;
      show_modal("#comment-modal");
    },

    countComments(comments) {
      let total = comments.filter((comment) => {
        return comment.text;
      });
      return total.length;
    },

    showFabricLists(fabrics) {
      let newArray = fabrics.map((fabric) => {
        return $Fabric.getCode(fabric);
      });
      return newArray.join(", ");
    },

    async submitOrder() {
      try {
        // edit orders
        if (this.selectedIndex != null) {
          let order = this.orders[this.selectedIndex];
          let res = await axios.put(
            "accessories_order/" + order.id,
            this.params
          );
          if (res) {
            this.selectedIndex = null;
            toastr.success("Successfully Updated");
          }
        }
        //new orders
        else {
          let res = await axios.post("accessories_order", this.params);
          if (res) {
            this.orders.unshift(res.data);
            toastr.success("Successfully Created");
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
      hide_modal("#order-modal");
    },

    async getOrders() {
      const params = this.serverParams;
      params["notArrived"] = this.notArrivedToggle ? 1 : 0;
      try {
        let res = await axios.get("accessories_order", { params });
        this.orders = res.data.data;
        this.totalRecords = res.data.total;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    filterByStatus() {
      this.serverParams.status = this.selectedStatusFilter;
      this.getOrders();
    },

    updateParams(params) {
      /**
       * Force the 3rd click to behave like the first click in the vue-good-table plugin
       * @see https://github.com/xaksis/vue-good-table/issues/794
       */
      if (params.orderBy && params.orderBy.type === "none") {
        params.orderBy.type =
          this.serverParams.orderBy.type === "asc" ? "desc" : "asc";
        this.$refs.order_table.sorts.map((sort, index) => {
          if (sort.field === params.orderBy.column) {
            this.$refs.order_table.sorts[index].type = params.orderBy.type;
          }
        });
      }
      this.serverParams = Object.assign({}, this.serverParams, params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getOrders();
    },

    selectionChanged(data) {
      this.selectedItems = data.selectedRows.map((item) => {
        return item.id;
      });
    },

    searchOrder(key) {
      this.$refs.order_table.reset();
      this.updateParams({ page: 1, keyword: key });
      this.getOrders();
    },

    onSortChange(params) {
      this.updateParams({
        orderBy: {
          type: params[0].type,
          column: params[0].field,
        },
      });
      this.getOrders();
    },

    onPerPageChange(params) {
      this.updateParams({ page: 1, perPage: params.currentPerPage });
      this.getOrders();
    },
  },
};
</script>

<style scoped>
.filter-container {
  padding-top: 7px;
}
</style>
